<rt-impact-tracker-insights
  [logoHeading]="dialogData()?.logoHeading || ''"
  [subheading]="dialogData()?.subheading || ''"
>
  <ng-container headingText>
    <div [innerHTML]="$safeNavigationMigration(dialogData()?.heading)" class="heading-text"></div>
  </ng-container>

  <ng-container insights>
    @for (card of dialogData()?.cards; track $index) {
      <rt-insights-card
        [iconName]="$any(card.icon)"
        [value]="card.value"
        [title]="card.title"
        [label]="card.label"
        [tooltip]="card.tooltip"
      />
    }
  </ng-container>
</rt-impact-tracker-insights>
